import React from "react";

//UI Material
import { Button } from "@mui/material";

export default function ContainedButton({
  text,
  endIcon,
  startIcon,
  onClick,
  sx,
  variant="contained",
  color = "secondary"
}) {
  return (
    <Button
      variant={variant}
      color={color}
      sx={{ color: "white", minWidth: "130px", ...sx }}
      endIcon={endIcon}
      startIcon={startIcon}
      size="small"
      onClick={onClick}
    >
      {text}
    </Button>
  );
}
